import { render, staticRenderFns } from "./HallNews.vue?vue&type=template&id=334e7246&scoped=true&"
import script from "./HallNews.vue?vue&type=script&lang=js&"
export * from "./HallNews.vue?vue&type=script&lang=js&"
import style0 from "./HallNews.vue?vue&type=style&index=0&id=334e7246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e7246",
  null
  
)

export default component.exports